'use client';

import React, { useMemo, useRef, useState } from 'react';
import { useTranslations } from 'next-intl';
import { storeFront } from '@/lib/utils/routeLinks';
import TagsCombobox from '@/components/ui/TagsCombobox';
import useAppLocale from '@/hooks/useAppLocale';
import { categories } from '@/constant/configs';

type TagsDropdownProps = {
  handleMenuClose?: () => void;
};

const TagsDropdown = ({ handleMenuClose }: TagsDropdownProps) => {
  const t = useTranslations();
  const { lang } = useAppLocale();

  const inititalTags = categories.map((category) => ({
    value: category.id.toString(),
    label: category.title[lang as 'en' | 'de'],
  }));

  const [searchQuery, setSearchQuery] = useState('');

  const filteredCategories = useMemo(() => {
    if (!searchQuery.trim()) return inititalTags;
    return inititalTags.filter((category) =>
      category.label.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [searchQuery]);

  const handleSelect = (id: string) => {
    const selectedCategory = categories.find(
      (category) => category.id?.toString() === id
    );
    if (selectedCategory) {
      if (handleMenuClose) {
        handleMenuClose();
      }
      const url =
        selectedCategory?.link ??
        `${storeFront.onlineShops.de()}?tag_ids=${selectedCategory.id}`;
      window.open(url, '_blank');
    }
  };

  return (
    <div className="relative" tabIndex={0}>
      <TagsCombobox
        categories={filteredCategories}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        onSelect={handleSelect}
      />
    </div>
  );
};

export default TagsDropdown;
